module.exports = __webpack_public_path__ + "img/check-circle.2d366982.svg";